import { render } from "./client-info.vue?vue&type=template&id=6decb9a7&scoped=true"
import script from "./client-info.vue?vue&type=script&lang=js"
export * from "./client-info.vue?vue&type=script&lang=js"

import "./client-info.vue?vue&type=style&index=0&id=6decb9a7&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6decb9a7"]])

export default __exports__